import React, { useEffect, useState } from "react";
import throttle from "lodash/throttle";
import get from "lodash/get";
import { useSelector } from "react-redux";
import { Link } from "@quintype/components";
import { SvgIconHandler } from "../SvgIconHandler";
import { useDeviceType } from "../../customHooks/useDeviceType";
import { getCategoryAndSubCategory, getTemplateName } from "../../../ga-utils";

import "./news-summaries-button.m.css";

export const NewsSummariesButton = () => {
  const [showSummaryIconLabel, setShowSummaryIconLabel] = useState(true);
  const pageType = useSelector((state) => get(state, ["qt", "pageType"], {}));

  const deviceType = useDeviceType();
  const isDesktop = deviceType === "desktop";
  const handleScroll = () => {
    if (window.scrollY > 500) {
      setShowSummaryIconLabel(isDesktop);
    } else {
      setShowSummaryIconLabel(true);
    }
  };

  const throttledHandleScroll = throttle(handleScroll, 200);
  useEffect(() => {
    window.addEventListener("scroll", throttledHandleScroll);
    return () => {
      window.removeEventListener("scroll", throttledHandleScroll);
      throttledHandleScroll.cancel();
    };
  }, [throttledHandleScroll]);

  // Using ref to prevent double tracking from touchstart + mousedown on mobile
  const hasTracked = React.useRef(false);

  const trackButtonClick = (event) => {
    // Skip if already tracked within this click/touch sequence
    if (hasTracked.current) return;

    if (typeof window !== "undefined" && window.dataLayer) {
      const { category, subCategory, contentId } = getCategoryAndSubCategory(window.location, pageType);
      window.dataLayer.push({
        event: "dl_cta_click",
        event_action: "short_news_button_click",
        link_url: "/short-news",
        link_text: "view all summaries",
        category: category,
        sub_category: subCategory,
        content_id: contentId,
        template_name: getTemplateName(pageType),
        platform: window.innerWidth >= 768 ? "desktop" : "mobile",
      });

      hasTracked.current = true;

      // Reset flag after a short delay (after the event sequence completes)
      setTimeout(() => {
        hasTracked.current = false;
      }, 300);
    }
  };

  return (
    <Link
      href="/short-news"
      aria-label="news-summaries"
      disableAjaxLinks={true}
      onMouseDown={trackButtonClick}
      onTouchStart={trackButtonClick}
    >
      <div styleName={`mobile-btn ${!showSummaryIconLabel ? "small-mobile-btn" : ""}`}>
        <SvgIconHandler type={"summary"} />
        {showSummaryIconLabel && <span styleName="mobile-btn-text">{"News Summaries"}</span>}
      </div>
    </Link>
  );
};
